import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

/** Per-brand attribution from bound conversion sources (PRD-0188 G1). */
export interface AttributionCounts {
  signups: number;
  sales: number;
  /** Minor units per ISO currency; currencies are never summed together. */
  revenue_by_currency: Record<string, number>;
}

export interface AttributionReportData {
  binding_version: number;
  truncated: boolean;
  window: { from: string; to: string; days: number };
  totals: AttributionCounts;
  by_channel: Array<{ source: string; medium: string } & AttributionCounts>;
  by_campaign: Array<{ utm_campaign: string; brief_id: string | null } & AttributionCounts>;
  by_post: Array<{ brief_id: string; title: string | null; surface: string | null; published_url: string | null } & AttributionCounts>;
  unattributed: AttributionCounts;
}

export type AttributionResponse =
  | { status: "ok"; data: AttributionReportData }
  | { status: "unavailable"; data: null; reason: "ATTRIBUTION_REPORT_NOT_CONFIGURED" };

export function useAttribution(brandId: string | undefined, days = 30) {
  return useQuery<AttributionResponse>({
    queryKey: ["attribution", brandId, days],
    queryFn: () => api.get<AttributionResponse>(`/api/brands/${encodeURIComponent(brandId!)}/attribution?days=${days}`),
    enabled: !!brandId,
    staleTime: 5 * 60 * 1000,
  });
}
